export const LOYALTY_MARKETS = Object.freeze({
  IT: "IT",
  CH: "CH"
});
const IT_CONVENTION_TYPES = Object.freeze(["BUS", "UNI", "WAO", "VIP", "QRCODE"]);
const CH_CONVENTION_TYPES = Object.freeze(["BUS"]);
const ITALIAN_LOYALTY_LEGAL_PATHS = Object.freeze(["/condizioni-m-loyalty", "/informativa-m-loyalty"]);
export const resolveLoyaltyMarket = storeViewCode => {
  const normalizedStoreViewCode = String(storeViewCode || "").trim().toLowerCase();
  return normalizedStoreViewCode.startsWith("miscusi_ch") ? LOYALTY_MARKETS.CH : LOYALTY_MARKETS.IT;
};
export const isSwissEmployeeCouponTable = function () {
  let {
    storeViewCode,
    tableDescription,
    customerEmail
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return resolveLoyaltyMarket(storeViewCode) === LOYALTY_MARKETS.CH && tableDescription === "D50" && Boolean(customerEmail);
};
const normalizeConfiguredUrl = value => {
  if (typeof value !== "string") {
    return null;
  }
  const url = value.trim();
  if (!url) {
    return null;
  }
  if (url.startsWith("/") && !url.startsWith("//")) {
    return url;
  }
  try {
    const parsedUrl = new URL(url);
    const isLocalDevelopmentUrl = parsedUrl.protocol === "http:" && ["localhost", "127.0.0.1"].includes(parsedUrl.hostname);
    return parsedUrl.protocol === "https:" || isLocalDevelopmentUrl ? parsedUrl.toString() : null;
  } catch (error) {
    return null;
  }
};
const normalizeSwissLegalUrl = value => {
  const url = normalizeConfiguredUrl(value);
  if (!url || url.startsWith("/")) {
    return null;
  }
  const pathname = new URL(url).pathname.replace(/\/$/, "");
  return ITALIAN_LOYALTY_LEGAL_PATHS.includes(pathname) ? null : url;
};
export const createLoyaltyCapabilities = function () {
  let {
    storeViewCode,
    isCouponActive = false,
    isEdenredWalletActive = false,
    chTermsUrl,
    chPrivacyUrl
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const market = resolveLoyaltyMarket(storeViewCode);
  const isSwitzerland = market === LOYALTY_MARKETS.CH;
  const termsUrl = isSwitzerland ? normalizeSwissLegalUrl(chTermsUrl) : "/condizioni-m-loyalty";
  const privacyUrl = isSwitzerland ? normalizeSwissLegalUrl(chPrivacyUrl) : "/informativa-m-loyalty";
  return Object.freeze({
    market,
    isSwitzerland,
    accountAccess: true,
    pointsEarning: true,
    pointsBalanceHistory: !isSwitzerland,
    pointsRedemption: true,
    companyConventions: true,
    accountBookings: true,
    accountHelp: !isSwitzerland,
    consentManagement: !isSwitzerland,
    coupons: !isSwitzerland && Boolean(isCouponActive),
    birthdayBenefit: !isSwitzerland,
    universityConvention: !isSwitzerland,
    doublePointsBenefit: !isSwitzerland,
    climateSquadBenefit: !isSwitzerland,
    dateOfBirthCollection: !isSwitzerland,
    profilingConsent: !isSwitzerland,
    edenredWallet: !isSwitzerland && Boolean(isEdenredWalletActive),
    supportedConventionTypes: isSwitzerland ? CH_CONVENTION_TYPES : IT_CONVENTION_TYPES,
    fallbackCurrencyCode: isSwitzerland ? "CHF" : "EUR",
    fallbackCurrencySymbol: isSwitzerland ? "CHF" : "€",
    legal: Object.freeze({
      termsUrl,
      privacyUrl,
      ready: Boolean(termsUrl && privacyUrl),
      consentRequired: !isSwitzerland || Boolean(termsUrl && privacyUrl),
      requiresDeploymentConfiguration: isSwitzerland
    })
  });
};